<button
    class="access-edit-button"
    (click)="onEditClicked($event)">
    <div class="mat-colors flex flex-row w-full">
        <mat-icon>edit</mat-icon>
        <div class="offer-name">SFR FTTH 1Go/s</div>
    </div>
</button>